import { Stage } from "../constants";

export const AUTH_CONFIG: Record<string, Record<string, string>> = {
  beta: {
    userPoolId: "us-west-2_QPHyTAtE6",
    clientId: "4vpemkd6leo1gnrfgkpvlq0bba",
    domain: "abregistration-console-beta.auth.us-west-2.amazoncognito.com",
  },
  prod: {
    userPoolId: "us-west-2_k6Rk5XF9Q",
    clientId: "4pkdbgdqqpotjofa7uoefnsfrd",
    domain: "abregistration-console-prod.auth.us-west-2.amazoncognito.com",
  },
};

export const ACCOUNT_ID: Record<Stage, string> = {
  beta: "634133347187",
  prod: "237126355621",
};

export const BARTON_WEBSITE_URL: Record<string, Record<string, string>> = {
  NA: {
    beta: "https://b2b-verify-console.integ.amazon.com/secure/dev-console/customer/debug",
    prod: "https://b2b-verify-console-iad.amazon.com/secure/dev-console/customer/debug",
  },
  EU: {
    beta: "https://b2b-verify-console-eu.integ.amazon.com/secure/dev-console/customer/debug",
    prod: "https://b2b-verify-console-dub.dub.proxy.amazon.com/secure/dev-console/customer/debug",
  },
  FE: {
    beta: "https://b2b-verify-console-fe.integ.amazon.com/secure/dev-console/customer/debug",
    prod: "https://b2b-verify-console-fe-pdx.pdx.proxy.amazon.com/secure/dev-console/customer/debug",
  },
};

export const BAC_URL: Record<string, Record<string, string>> = {
  NA: {
    beta: "https://b2b-console.integ.amazon.com/secure/console2/customer/",
    prod: "https://b2b-console.amazon.com/secure/console/epd/customer/",
  },
  EU: {
    beta: "https://b2b-console-eu.integ.amazon.com/secure/console2/customer/",
    prod: "https://b2b-console-dub.aka.amazon.com/secure/console/epd/customer/",
  },
  FE: {
    beta: "https://b2b-console-fe.integ.amazon.com/secure/console2/customer/",
    prod: "https://b2b-console-pdx.aka.amazon.com/secure/console/epd/customer/",
  },
};
